import React from "react";
import { Box, Tooltip, Typography } from '@mui/material';
import { grey } from '@mui/material/colors';
import { formatNumber } from 'helpers/getNumberFormats';

export const PercentageBar = ({ inventoryPercentage }) => {
    return (
        <Box style={{
            width: '100%',
            height: '15vh',
            display: 'flex',
            flexWrap: 'wrap',
            justifyContent: 'center',
            alignContent: 'center',
            flexDirection: 'column'
        }}>
            <Typography variant='h4' sx={{ color: '#4caf50', alignSelf: 'center', fontWeight: 'bold' }} >
                {`${inventoryPercentage % 1 === 0 ? inventoryPercentage : formatNumber(inventoryPercentage)}%`}
            </Typography>
            <Box style={{
                width: '96%', height: '10%', borderRadius: 20, border: 'solid', borderWidth: 1,
                borderColor: grey[400], alignContent: 'end', overflow: 'hidden'
            }}>
                <Tooltip title={`${formatNumber(inventoryPercentage)}% de Capacidad`} placement='top'>
                    <Box style={{ backgroundColor: '#4caf50', height: `100%`, width: `${inventoryPercentage}%` }} />
                </Tooltip>
            </Box>
        </Box>
    )
}